<div class="box">

  <div class="column">
    <img src="assets/bilder/anderes/geschenk-box-gelb.webp" alt="Geschenk">

    <div class="buttons">

      <app-button (click)="listen(1)">
        👂 <br> Lauschen
      </app-button>

      @if (statesService.showBox && !statesService.states.started) {
        <app-button (click)="openBox(1)">
          🎁 <br> Päckchen öffnen
        </app-button>
      }

    </div>

  </div>

  <div class="column">
    <img src="assets/bilder/anderes/geschenk-box-gelb.webp" alt="Geschenk" class="second cat-box">

    <div class="buttons">

      <app-button  (click)="listen(2)">
        👂 <br> Lauschen
      </app-button>

      @if (statesService.showBox && !statesService.states.started) {
        <app-button (click)="openBox(2)">
          <span class="cat-box">🎁</span> <br> Päckchen öffnen
        </app-button>
      }

    </div>

  </div>

</div>
